(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["playroots-landing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var entries = [];

    function reducedMotion() {
      try {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      } catch (error) {
        return false;
      }
    }

    function ensureSource(video) {
      var inline = video.getAttribute('data-video-src') || video.getAttribute('data-src');
      if (inline) {
        if (video.getAttribute('src') !== inline) {
          video.removeAttribute('data-video-src');
          video.removeAttribute('data-src');
          video.src = inline;
          try { video.load(); } catch (error) {}
        }
        return;
      }
      var source = video.querySelector('source[data-src]');
      if (source && !source.hasAttribute('src')) {
        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
        try { video.load(); } catch (error) {}
      }
    }

    function play(video) {
      if (video.prUserPaused) return;
      ensureSource(video);
      var result = video.play();
      if (result && typeof result.catch === 'function') result.catch(function () {});
    }

    function pause(video) {
      try { video.pause(); } catch (error) {}
    }

    function update() {
      var hidden = document.hidden;
      var skip = reducedMotion();
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (!entry.el.isConnected) continue;
        if (entry.visible && !hidden && !skip) play(entry.el);
        else pause(entry.el);
      }
    }

    function bind(video) {
      var entry = { el: video, visible: false, observer: null };

      video.addEventListener('playing', function () {
        video.classList.add('pr-inview-active');
      });
      video.addEventListener('pause', function () {
        video.classList.remove('pr-inview-active');
      });
      video.addEventListener('ended', function () {
        video.classList.remove('pr-inview-active');
      });

      if ('IntersectionObserver' in window) {
        entry.observer = new IntersectionObserver(function (records) {
          entry.visible = !!(records[0] && records[0].isIntersecting);
          update();
        }, { threshold: 0.05 });
        entry.observer.observe(video);
      } else {
        entry.visible = true;
      }

      return entry;
    }

    function scan() {
      var nodes = document.querySelectorAll('[data-pr-inview-video]');
      var next = [];
      for (var i = 0; i < nodes.length; i++) {
        var video = nodes[i];
        var entry = video.prLandingVideo;
        if (!(entry && entry.el === video)) {
          entry = bind(video);
          video.prLandingVideo = entry;
        }
        next.push(entry);
      }
      entries = next;
      update();
    }

    document.addEventListener('visibilitychange', update);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan, { once: true });
    } else {
      scan();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
